module.exports = __webpack_public_path__ + "img/hamburguesa_carne.75259771.jpeg";